import { IconProps } from '@/types/icons';

export const IconNoDataFound = ({ className }: IconProps) => {
  return (
    <svg
      fill="currentColor"
      className={className}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="383"
      height="336"
      viewBox="0 0 383 336"
      xmlSpace="preserve"
    >
      <path d="M99.0543 25.394V39.3575" stroke="#DFDFDF" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M92.0399 32.3759H106.037" stroke="#DFDFDF" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M258.022 113.461C230.84 113.461 203.171 112.357 177.288 105.148C151.892 98.1016 128.575 84.4304 107.79 68.6159C94.1829 58.3219 81.8098 50.1062 64.1431 51.3402C46.8598 52.2754 30.3321 58.7289 16.9886 69.7525C-5.48444 89.4312 -2.10699 125.899 6.88873 151.423C20.3985 189.968 61.5126 216.824 96.4562 234.197C136.823 254.363 181.185 266.085 225.644 272.807C264.615 278.75 314.692 283.036 348.466 257.61C379.48 234.197 387.989 180.811 380.39 144.766C378.546 134.117 372.875 124.509 364.444 117.748C342.653 101.804 310.145 112.455 285.659 112.974C276.565 113.169 267.31 113.396 258.022 113.461Z"
        fill="white"
      />
      <path
        d="M214.5 7C216.433 7 218 5.43299 218 3.5C218 1.567 216.433 0 214.5 0C212.567 0 211 1.567 211 3.5C211 5.43299 212.567 7 214.5 7Z"
        fill="#DFDFDF"
      />
      <path
        d="M192.812 336C258.654 336 312.029 332.671 312.029 328.564C312.029 324.457 258.654 321.127 192.812 321.127C126.97 321.127 73.594 324.457 73.594 328.564C73.594 332.671 126.97 336 192.812 336Z"
        fill="#F5F5F5"
      />
      <path
        d="M288.646 248.907H82.7188C81.3407 248.906 79.9792 248.606 78.7286 248.027C77.4779 247.448 76.368 246.604 75.4754 245.554C74.5829 244.504 73.9291 243.273 73.5593 241.946C73.1894 240.618 73.1124 239.226 73.3334 237.866L99.6711 78.163C100.027 75.9403 101.165 73.9176 102.879 72.4591C104.594 71.0005 106.773 70.2019 109.024 70.207H314.951C316.328 70.2072 317.689 70.5072 318.938 71.0863C320.188 71.6654 321.296 72.5097 322.186 73.5605C323.076 74.6112 323.727 75.8432 324.093 77.1707C324.458 78.4983 324.531 79.8896 324.304 81.2479L298.097 240.951C297.732 243.187 296.578 245.219 294.845 246.679C293.111 248.138 290.912 248.929 288.646 248.907Z"
        fill="#DFDFDF"
      />
      <path
        d="M291.184 66.0305L168.95 11.459C165.347 9.85043 161.122 11.467 159.513 15.0698L120.773 101.831C119.164 105.434 120.781 109.659 124.384 111.267L246.618 165.839C250.221 167.447 254.446 165.831 256.054 162.228L294.795 75.4666C296.404 71.8638 294.787 67.6391 291.184 66.0305Z"
        fill="white"
        stroke="#DFDFDF"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M186.868 82.8392C190.086 78.325 194.765 75.0618 200.113 73.6028C205.462 72.1437 211.15 72.5785 216.214 74.8334C221.279 77.0884 225.408 81.0247 227.902 85.9755C230.396 90.9263 231.101 96.587 229.898 101.998"
        stroke="#DFDFDF"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M245.324 77.9356C247.171 77.9356 248.669 76.4381 248.669 74.5909C248.669 72.7437 247.171 71.2462 245.324 71.2462C243.477 71.2462 241.979 72.7437 241.979 74.5909C241.979 76.4381 243.477 77.9356 245.324 77.9356Z"
        fill="#DFDFDF"
      />
      <path
        d="M196.871 56.3086C198.718 56.3086 200.216 54.8111 200.216 52.9639C200.216 51.1166 198.718 49.6191 196.871 49.6191C195.023 49.6191 193.526 51.1166 193.526 52.9639C193.526 54.8111 195.023 56.3086 196.871 56.3086Z"
        fill="#DFDFDF"
      />
      <path
        d="M287.737 248.842H80.8033C78.2853 248.833 75.8734 247.827 74.096 246.044C72.3185 244.26 71.3205 241.845 71.3205 239.327V93.4254C71.2902 92.1596 71.5129 90.9006 71.9755 89.722C72.4381 88.5434 73.1313 87.469 74.0144 86.5617C74.8976 85.6544 75.953 84.9325 77.1187 84.4383C78.2845 83.944 79.5371 83.6874 80.8033 83.6834H156.179C157.928 83.6899 159.641 84.1782 161.131 85.0948C162.621 86.0114 163.829 87.3208 164.623 88.8791L175.372 109.922C176.163 111.482 177.37 112.794 178.861 113.711C180.351 114.628 182.066 115.115 183.816 115.117H287.737C290.252 115.117 292.664 116.116 294.443 117.895C296.221 119.673 297.22 122.085 297.22 124.6V239.327C297.22 241.845 296.222 244.26 294.445 246.044C292.667 247.827 290.255 248.833 287.737 248.842Z"
        fill="white"
        stroke="#DFDFDF"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M255.878 120.086C243.924 120.08 232.236 123.618 222.293 130.255C212.349 136.891 204.598 146.327 200.019 157.369C195.439 168.412 194.238 180.564 196.566 192.288C198.895 204.013 204.648 214.784 213.099 223.239C221.55 231.694 232.319 237.453 244.043 239.788C255.768 242.122 267.921 240.927 278.967 236.354C290.012 231.781 299.453 224.035 306.095 214.096C312.737 204.158 316.283 192.472 316.283 180.519C316.283 164.496 309.92 149.13 298.593 137.798C287.266 126.465 271.902 120.095 255.878 120.086Z"
        fill="white"
        stroke="#DFDFDF"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M298.876 224.357L314.984 240.464" stroke="#DFDFDF" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M313.163 232.638L308.159 237.873C305.916 240.219 306 243.94 308.346 246.183L351.775 287.695C354.121 289.939 357.842 289.855 360.085 287.508L365.09 282.274C367.333 279.927 367.249 276.207 364.903 273.964L321.474 232.451C319.127 230.208 315.407 230.292 313.163 232.638Z"
        fill="#DFDFDF"
      />
      <path d="M345.316 3.1825V17.1784" stroke="#DFDFDF" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M338.301 10.1966H352.298" stroke="#DFDFDF" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
};
